const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  search ({ state, commit, rootState }, params) {
    return rootState.axios.get('/cc/v1frontend/duty/search', {params})
  },
  batchCreate ({ state, commit, rootState }, params) {
    return rootState.axios.post('/cc/v1frontend/duty/batch-create', params)
  },
  updateDutyFile ({ state, commit, rootState }, params) {
    return rootState.axios.post('/cc/v1frontend/duty/update-duty-file', params, {
      headers: {'Content-Type': 'multipart/form-data'},
      noShowError: true,
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/cc/duty.js